import React from "react";

import AppBar from "./AppBar";
import Introduction from "./Introduction";
//import Features from "./Features";
//import FAQ from "./FAQ";
import JoinUs from "./JoinUs";

function Presentation() {
  return (
    <React.Fragment>
      <AppBar />
      <Introduction />
      {/*<Features />*/}
      {/*<FAQ />*/}
      <JoinUs />
    </React.Fragment>
  );
}

export default Presentation;
